import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/certifications/iso-9001.svg")